import React from "react";
var __jsx = React.createElement;
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconOrderFailure } from "./assets/order-failure.svg";
import { ReactComponent as IconOrderSuccess } from "./assets/order-success.svg";
import FullPageModal from "../../../FullPageModal";
import { updateBestBuySubmitStatus } from "../../../../state/dex/actions";
import { useBestBuySubmitStatus } from "../../../../state/dex/hooks";
import { BestBuySubmitStatus } from "../../../../state/dex/type";
import { useAppDispatch } from "../../../../state/hooks";
import { BackButton, ModalContent, ModalContentWrapper, ModalTitle } from "./styled";
import LottieLoading from "../../../LottieLoading";
import { useEffect } from 'react';
import { lockBody } from "../../../../utils/lockBody";
var StatusMapIcon = {
  [BestBuySubmitStatus.Idle]: null,
  [BestBuySubmitStatus.SignOrderPending]: LottieLoading,
  [BestBuySubmitStatus.SignOrderSuccess]: IconOrderSuccess,
  [BestBuySubmitStatus.SignOrderFailure]: IconOrderFailure,
  [BestBuySubmitStatus.CancelOrderPending]: LottieLoading,
  [BestBuySubmitStatus.CancelOrderSuccess]: IconOrderSuccess,
  [BestBuySubmitStatus.CancelOrderFailure]: IconOrderFailure,
  [BestBuySubmitStatus.CancelOrderRejected]: IconOrderFailure
};
var StatusMapI18n = {
  [BestBuySubmitStatus.Idle]: '',
  [BestBuySubmitStatus.SignOrderPending]: 'sign_best_buy_pending',
  [BestBuySubmitStatus.SignOrderSuccess]: 'sign_order_success',
  [BestBuySubmitStatus.SignOrderFailure]: 'sign_order_failure',
  [BestBuySubmitStatus.CancelOrderPending]: 'cancel_order_pending',
  [BestBuySubmitStatus.CancelOrderSuccess]: 'cancel_order_success',
  [BestBuySubmitStatus.CancelOrderFailure]: 'cancel_order_failure',
  [BestBuySubmitStatus.CancelOrderRejected]: 'sign_order_failure'
};

var OrderStatus = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var status = useBestBuySubmitStatus();
  var inProgress = [BestBuySubmitStatus.SignOrderPending, BestBuySubmitStatus.CancelOrderPending].includes(status);
  var dispatch = useAppDispatch();

  var onClose = () => {
    dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.Idle));
  };

  useEffect(() => {
    lockBody(status !== BestBuySubmitStatus.Idle);
  }, [status]);
  if (status === BestBuySubmitStatus.Idle) return null;
  var StatusIcon = StatusMapIcon[status] || IconOrderFailure;
  return __jsx(FullPageModal, {
    showClose: false,
    visible: Boolean(status)
  }, __jsx(ModalContentWrapper, null, __jsx(ModalTitle, null, t('authorize_order')), __jsx(ModalContent, null, __jsx("div", {
    className: "status-img"
  }, __jsx(StatusIcon, null)), __jsx("p", null, t(StatusMapI18n[status] || status)), !inProgress && __jsx(BackButton, {
    onClick: onClose
  }, t('back')))));
};

export default OrderStatus;